import Moment from 'moment';
import { ActionTypes } from '../constants';

const defaults = {
  logs: [],
};

export interface ActionType {
  type: string;
  payload: any;
}

export default (state = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.SERVERAPP_ADD_EXCEPTION: {
      const { logs } = state;
      const { log } = action.payload;
      const newLines = [...logs];
      if (logs.length >= 100) {
        newLines.splice(0, 1);
      }
      const formattedLine = `${Moment(new Date()).format('YYYY-MM-DD hh:mm:ss')} - ${
        log.message
      } - ${log.stackTrace}`;
      return {
        ...state,
        logs: newLines.concat(formattedLine),
      };
    }
    default: {
      return { 
          ...state,
          logs: [],
        };
    }
  }
};
